module.exports = __webpack_public_path__ + "static/img/TV.255a31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/TV.png
// module id = zspv
// module chunks = 70